import ApiClient from './apiClient'
import { GetMemberExistenceResponse } from '../types/memberExistence'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMemberExistence = async (): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_existence',
  (result: GetMemberExistenceResponse) => result,
)

export default getMemberExistence
